import DeliveryFormV3 from "@components/Delivery/DeliveryFormV3";
import { useUserContext } from "@contexts/UserContext/index.context";
import { UserRole } from "@types_def/models/user.type";
import type { SchemaKeys } from "@utils/functions/Delivery/schema";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import type { DeliveryFormValues } from "@/components/Delivery/DeliveryFormV3/types";
import { transformToCreateInput } from "@/components/Delivery/DeliveryFormV3/utils/transform";
import { useCreateDeliveryMutation } from "@/libs/generated/hooks";

function NewDeliveryV3() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { type } = useParams<{
    type?: SchemaKeys;
  }>();
  if (!type) {
    throw new Error("Missing type param");
  }

  const { userState } = useUserContext();
  if (!userState) {
    throw new Error("Missing userState");
  }

  const isAdmin = userState["custom:role"] === UserRole.ADMIN;
  const formId = `new-delivery-form-v3_${type}`;

  const createDelivery = useCreateDeliveryMutation({
    onSuccess: ({ createDelivery }) => {
      console.log("🎉 Delivery created:", createDelivery);
      // Drop the create-form draft so the next new delivery starts blank
      sessionStorage.removeItem(`delivery-form-v2-${formId}`);
      sessionStorage.removeItem(`delivery-form-${formId}`);
      const { id, status } = createDelivery;
      if (id != null) {
        const lastStep = type === "two-way-delivery" ? 3 : 2;
        const navPath = isAdmin
          ? `/admin/pilot/edit-deal/${type}/${status?.toLowerCase()}/${id}?step=${lastStep}`
          : `/client/edit-delivery/${type}/requested/${id}?step=${lastStep}`;

        void navigate(navPath);
      }
    },
    onError: (error) => {
      console.error("❌ Error creating delivery:", error);
    },
  });

  const handleSubmit = (data: DeliveryFormValues) => {
    console.log("📤 Submitting delivery data:", data);
    const createInput = transformToCreateInput(data, type);
    console.log("📤 Transformed create input:", createInput);
    createDelivery.mutate({ createInput });
  };

  return (
    <DeliveryFormV3
      type={type}
      formId={formId}
      title={t("common.shared.new-delivery")}
      onSubmit={handleSubmit}
    />
  );
}

export default NewDeliveryV3;
